var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-icon-badge",class:_vm.color ? `c-icon-badge--${_vm.color}` : ''},[_c('i',{class:`fa-regular ${_vm.icon}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }